import React, { useState, useEffect, useMemo, useRef } from "react";

import "../../components/WorklistScreenComponent/WorklistCardComponent.css";
import { IoMenu } from "react-icons/io5";
import { Button, InputNumber, Pagination } from "antd";
import { DetailContentScreen } from "./DetailContentScreen";
import WorkListSideBarElementUse from "./WorkListSideBarElementUse";
import { WorklistCardComponent } from "../../components/WorklistScreenComponent/WorklistCardComponent";
// import Pagination from "react-bootstrap/Pagination";
import { TreeSelectNewRequest } from "../../components/TreeSelectNewRequest/TreeSelectNewRequest";
import moment, { Moment } from "moment";
import { IMemoButtonModel } from "../../IRequestModel/IMemoButtonModel";
import { FooterComponents } from "../../components/FooterComponents/FooterComponents";
import {
  GetWorkListByTaskGroup,
  Getinfomation,
} from "../../Services/WorklistService";
import { AnimatePresence, motion } from "framer-motion";
import {
  ActionMemoPage,
  GetButtonMemoByMemoId,
  GetAllMemo,
  GetMemoDetail,
} from "../../Services/MemoService";
import { GetAllHistory } from "../../Services/HistoryService";
import { GetAllAttachFiles } from "../../Services/AttachFileService";
import { GetAllApprovals } from "../../Services/ApprovalService";
import withPerMission from "../../components/HOC/withPermission";
import { IAutoNumberAttibute } from "../../IRequestModel/IAutoNumberFormat";
import { GetAutoNumber } from "../../Services/RequestControlService";
import useAlert from "../../hooks/useAlert";
import { useUserContext } from "../../Context/UserContext";
import {
  IGetWorklistRequest,
  ISearchWorklist,
  ITodo,
  IWorklistDetail,
  TodoType,
  WorklistHeaderType,
  WorklistSerachType,
} from "../../IRequestModel/IWorklistModel";
import { IUserModel } from "../../IRequestModel/IUserModel";
import { useTranslation } from "react-i18next";
import useMemoPage from "../../hooks/useMemoPage";
import { GetAllEmployee } from "../../Services/EmployeeService";
import useLoading from "../../hooks/useLoading";
import useMasterSetting from "../../hooks/useMasterSetting";
import { onProcessLogicLineApprove } from "../../Helper/LineApprove";
import {
  checkCallLogic,
  handleDatasourcerelated,
  onProcessLogicDataSourceRelated,
  processHideControlLogic,
  checkIsCorrect,
} from "../../Helper/LogicHelper";
import {
  getDefValueInTemplate,
  getRefInforValue,
  callGenAutoNumber,
  genAutoNum,
  checkRequireFromTemplate,
  deserializeColumnJsonCondValue,
} from "../../Helper/RequestScreenHelper";
import { onCheckUserRolePermissionInLogic } from "../../Helper/RolePermisstion";
import { formatKeyLogicData } from "../../Helper/formatKeyLogicData";
import {
  ILogic,
  ILogicTypeShowHide,
  ILogicTypeReference,
  ILogicTypeReladToLoadData,
  ILogicReferenceInformation,
  ILogicTypeDataLineApprove,
  ILogicTypeHideControl,
  ILogicTypeReadOnly,
} from "../../IRequestModel/ILogicModel";
import { IMemoDetailModel } from "../../IRequestModel/IMemoDetailModel";
import { IRolePermission } from "../../IRequestModel/IRolePermission";
import { GetRolePermissionByUser } from "../../Services/RoleServices";
import { LogicOperatorType, LogicType } from "../../constants/logic-type";
import { LoadLogic } from "../../Services/TemplateService";
import _, { isUndefined } from "lodash";
import {
  IApprovaReadHide,
  IReqConditions,
} from "../../IRequestModel/IListApprovalDetailsModel";
import { json } from "stream/consumers";
interface Props {
  responeConfig: any;
}
const WorkListScreen = (props: Props) => {
  const [userData] = useUserContext();
  const { toggleAlert } = useAlert();

  //Worklist Data
  const [workListData, setWorkListData] = useState<ITodo[]>([]);
  const [dtWorkListData, setDTWorkListData] = useState<any>();
  const [totalCount, setTotalCount] = useState<number>(0);

  //Filter Option
  const [formTypeOptions, setFormTypeOptions] = useState<string[]>([]);
  const [companiesOptions, setCompaniesOptions] = useState<string[]>([]);
  const [departmentsOptions, setDepartmentsOptions] = useState<string[]>([]);
  const [formStatusOptions, setFormStatusOptions] = useState<string[]>([]);

  //Filter data
  const [searchObject, setSearchObject] = useState<ISearchWorklist>({
    company: [],
    date: [],
    department: [],
    form: [],
    keyword: "",
    status: [],
  });
  const { t } = useTranslation(["translation"]);
  //Pagination
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemPerPage, setItemPerPage] = useState<number>(5);
  const [buttonType, setButtonType] = useState("");
  const sessionHeader = sessionStorage.getItem("headerTask");
  const sessionTask = sessionStorage.getItem("task");
  //Toggle
  const [isShowPdfData, setIsShowPdfData] = useState(true);
  const [isCardLoading, setIsCardLoading] = useState<boolean>(false);
  const { setLoad } = useLoading();
  const [onDetailLoading, setOnDetailLoading] = useState<boolean>(false);
  const [toggleDetail, setToggleDetail] = useState<Boolean>(false);
  const [sidebarState, setSidebarState] = useState(false);

  const [currentMemoId, setCurrentMemoId] = useState<number>(0);
  const [taskHeader, setTaskHeader] = useState<string>(
    sessionHeader !== null ? sessionHeader : "To Do List"
  );
  const [currentIndex, setCurrentIndex] = useState<Number>(-1);
  const [selectedCard, setSelectedCard] = useState<IWorklistDetail>();
  const [menuButton, setMenuButton] = useState<any[]>([]);
  const [defaultTask, setDefaultTask] =
    useState<WorklistHeaderType>("To Do List");
  const [taskGourp, setTaskGourp] = useState<any>(
    sessionTask !== null ? sessionTask : "todo"
  );

  const { processQue, getMyMemoStatus, checkSyncMemo } = useMemoPage();
  const previousQue = useRef<number[]>([]);
  const [empList, setEmpList] = useState<IUserModel[]>([]);
  const [defaultValue, setDefaultValue] = useState<moment.Moment[] | any[]>([]);
  const abortController = useRef<AbortController | null>(null);
  const abortInforController = useRef<AbortController | null>(null);
  sessionStorage.removeItem("back");

  useEffect(() => {
    window.onpopstate = () => {
      if (location.pathname === "/Default") {
        sessionStorage.setItem("action_back", "yes");
      }
    };

    window.onbeforeunload = () => {
      if (location.pathname === "/Default") {
        sessionStorage.removeItem("task");
        sessionStorage.removeItem("searchObject");
        sessionStorage.removeItem("page");
        sessionStorage.removeItem("selectedCard");
        sessionStorage.removeItem("headerTask");
        sessionStorage.removeItem("currentMemoId");
        sessionStorage.removeItem("toggleSidebar");
      }
    };

    firstRetrieveData();

    return () => {
      window.removeEventListener("popstate", () => { });
      window.removeEventListener("beforeunload", () => { });
    };
  }, [t]);

  useEffect(() => {
    getMyMemoStatus();
  }, []);

  useEffect(() => {
    const text: any = sessionStorage.getItem("task");
    setIsCardLoading(true);
    if (abortController.current) {
      abortController.current.abort("Task group changed");
    }
    abortController.current = new AbortController();
    fetchWorklist(
      text == null ? taskGourp : text,
      true,
      taskGourp === "myrelate" && defaultValue.length > 0 ? true : false,
      taskGourp === "myrelate" && defaultValue.length > 0 ? true : false,
      searchObject,
      abortController
    );
    setIsCardLoading(false);

    return () => abortController.current?.abort("Component unmounted");
  }, [currentPage]);

  useEffect(() => {
    fecthSearchOptions();
  }, [taskGourp]);

  const fecthSearchOptions = async () => {
    if (abortInforController.current != null) {
      setTimeout(() => abortInforController?.current?.abort("Timeout"), 3000);
    }
    setIsCardLoading(true);
    try {
      abortInforController.current = new AbortController();
      let dateFrom = searchObject.date ? searchObject.date[0] : null;
      let dateTo = searchObject.date ? searchObject.date[1] : null;

      const dataJson: IGetWorklistRequest = {
        task: taskGourp,
        empId: userData?.EmployeeId?.toString(),
        iItemPerMore: 10000,
        CountMoreItem: 5,
        PageSize: 0,
        PageNumber: 0,
        FilterStatus: searchObject.status,
        ...dateFrom && {FilterDateFrom: moment(dateFrom).startOf('day').toDate() },
        ...dateTo && {FilterDateTo: moment(dateTo).endOf('day').toDate()},
        FilterText: searchObject.keyword,
        FilterCompanyName: searchObject.company,
        FilterDepartmentName: searchObject.department,
        FilterTemplateName: searchObject.form,
        UserPrincipalName: userData.Email,
      };
      let dataWorklist = await Getinfomation(
        dataJson,
        abortController.current?.signal
      );
      setFormStatusOptions(
        dataWorklist?.StatusName?.map((e: string) => {
          return { label: e, value: e };
        })
      );
      setFormTypeOptions(
        dataWorklist?.TemplateName?.map((e: string) => {
          return { label: e, value: e };
        })
      );
      setCompaniesOptions(
        dataWorklist?.CompanyName?.map((e: string) => {
          return { label: e, value: e };
        })
      );
      setDepartmentsOptions(
        dataWorklist?.DepartmentName?.map((e: string) => {
          return { label: e, value: e };
        })
      );
    } catch (error) {
      console.error(error);
    }
    // setIsCardLoading(false);
  };

  const fetchWorklist = async (
    task: TodoType,
    silent: boolean = false,
    fetchAll: boolean,
    showDefaultValue: boolean,
    _searchObject?: ISearchWorklist,
    abortController?: React.MutableRefObject<AbortController | null>
  ) => {
        setLoad(true);
        setIsCardLoading(true);
      _searchObject = _searchObject || searchObject;

    if (!!localStorage.getItem("workListFilterDate")&& !!localStorage.getItem("workListFilterDate2")){
    setDefaultValue([moment(localStorage.getItem("workListFilterDate")),moment(localStorage.getItem("workListFilterDate2"))])
    if(task==="myrelate")searchObject.date =[moment(localStorage.getItem("workListFilterDate")),moment(localStorage.getItem("workListFilterDate2"))] 
    }
    
    
    if (!silent) {
      checkSyncMemo();
    }

    let dateFrom = _searchObject.date ? _searchObject.date[0] : null;
    let dateTo = _searchObject.date ? _searchObject.date[1] : null;
    console.log(_searchObject ,fetchAll);
    if (task === "myrelate" && !dateFrom && !dateTo ) {

      setDefaultValue([
        moment(moment().subtract(1, 'months')).startOf('day'),
        moment(moment()).endOf('day'),

      ])
      localStorage.setItem("workListFilterDate", moment(moment().subtract(1, 'months')).startOf('day').toString()),
      localStorage.setItem("workListFilterDate2",  moment(moment()).endOf('day').toString())
    } else if (task === "myrelate")
      {
   
      }
      else {
      setDefaultValue([]);
    } // ส่ง defaultValue ไปแสดงใน calendar ของ sidebar    

    try {
      const dataJson: IGetWorklistRequest = {
        task: task,
        empId: userData?.EmployeeId?.toString(),
        iItemPerMore: 10000,
        CountMoreItem: 1,
        PageSize: itemPerPage,
        PageNumber: currentPage,
        FilterStatus: _searchObject.status,
        // ...dateFrom && {FilterDateFrom: moment(dateFrom).startOf('day').toDate() },
        // ...dateTo && {FilterDateTo: moment(dateTo).endOf('day').toDate()},
        ...(task === "myrelate" && !dateFrom && !dateTo &&  _searchObject.date!==null
          ? {
            FilterDateFrom: moment(moment().subtract(1, 'months')).startOf('day').toDate(),
            FilterDateTo: moment(moment()).endOf('day').toDate(),
          }
          : {
            ...(dateFrom && { FilterDateFrom: moment(dateFrom).startOf('day').toDate() }),
            ...(dateTo && { FilterDateTo: moment(dateTo).endOf('day').toDate() }),
          }),
        FilterText: _searchObject.keyword,
        FilterCompanyName: _searchObject.company,
        FilterDepartmentName: _searchObject.department,
        FilterTemplateName: _searchObject.form,
        UserPrincipalName: userData.Email,
      };
      setTaskGourp(task);
      await GetWorkListByTaskGroup(
        dataJson,
        abortController?.current?.signal
      ).then((data) => {
        if (data) {
          setTotalCount(data?.totalCount);
          setWorkListData(data?.workListDtos ?? []);
        }
      });
    } catch (error) {
      console.error(error);
    }
    setIsCardLoading(false);
    setLoad(false);
  };

  function toggleSideBar() {
    if (sidebarState) {
      setSidebarState(false);
      sessionStorage.setItem("toggleSidebar", "false");
     
       isUndefined(defaultValue[0]) && localStorage.setItem("workListFilterDate",moment(defaultValue[0]).toString())
        isUndefined(defaultValue[1]) &&localStorage.setItem("workListFilterDate2",moment(defaultValue[1]).toString())
    } else {
      setToggleDetail(false);
      setSidebarState(true);
      sessionStorage.setItem("toggleSidebar", "true");
      setDefaultValue([moment(localStorage.getItem("workListFilterDate")),moment(localStorage.getItem("workListFilterDate2"))])
    }
  }
  const onUpdateMemo = async (
    type: any,
    memoId: any,
    comment: string,
    waiting_for?: string,
    waiting_for_id?: number
  ) => {
    try {
      setLoad(true);
      setWorkListData([
        ...(workListData?.filter((e) => e.MemoID != memoId) || []),
      ]);

      // const _empData = empData.employeeData;
      let ddd = document.getElementsByTagName("body");
      ddd[0].style.overflow = "none";
      const requestBody = {
        Memoid: memoId,
        TemplateId: null,
        DocumentCode: null,
        SecretId: "",
        EmployeeId: userData.EmployeeId.toString(),
        actor: userData,
      };
      let _getMemoDetailById = await GetMemoDetail(requestBody);
      if (_getMemoDetailById) {
        let requestDetail = _getMemoDetailById.requestDetails;
        let listControlRunning = [];
        //set value
        requestDetail.memoDetail.comment = comment;
        requestDetail.memoDetail.actor = userData;
        requestDetail.memoDetail.waiting_for = waiting_for
          ? waiting_for
          : requestDetail.memoDetail.waiting_for;
        requestDetail.memoDetail.waiting_for_id = waiting_for_id
          ? waiting_for_id
          : requestDetail.memoDetail.waiting_for_id;

        if (!_getMemoDetailById.requestDetails.memoDetail.is_text_form) {
          //check control running

          if (requestDetail.memoDetail.template_desc) {
            let autoNumFormat: IAutoNumberAttibute = {
              formats: [],
              digit: 0,
              rowIndex: -1,
              colIndex: -1,
              showSymbol: "-",
            };
            let logic =
              _getMemoDetailById?.requestDetails.memoDetail.template_id !== 0
                ? await LoadLogic(
                    _getMemoDetailById?.requestDetails.memoDetail.template_id
                  )
                : [];
            const templateDescJson = JSON.parse(
              requestDetail.memoDetail.template_desc
            );
            templateDescJson.items.map((item: any) =>
              item.layout.map((_layout: any) => {
                if (_layout.template.type === "tb") {
                  _layout.template.attribute.column.forEach((col: any) => {
                    col.isReadOnly = false;
                    col.isShow = true;
                  });
                } else {
                  if (_layout?.template?.attribute?.require === "Y" && type === "approve") {
                    _layout.isShow = true;
                    _layout.isReadOnly = false;
                  }
                }
                return _layout;
              })
            ),
              initialActionFiedFormLineApprove(
                requestDetail.listApprovalDetails,
                templateDescJson.items,
                requestDetail.memoDetail,
                requestDetail.listFormNames[0].AdvanceForm,
                requestDetail.listFormNames[0],
                _getMemoDetailById?.requestDetails?.
                  listFormNames[0],
              );

            autoNumFormat = detechAutonumberFormula(templateDescJson);
            if (logic.length > 0) {
              await prepareInitialLogic(
                logic,
                templateDescJson,
                requestDetail.memoDetail,
                requestDetail.listApprovalDetails
              );
            }

            let errorList: any[] = [];
            const req = _getMemoDetailById?.requestDetails.memoDetail?.requestor?.EmployeeId === userData.EmployeeId;
            templateDescJson.items.forEach((item: any) =>
              item.layout.forEach((_layout: any) => {
                if (_layout.isReadOnly === undefined) {
                  _layout.isReadOnly = false;
                }
                if (_layout.template.attribute && _layout?.isShow) {
                  if (!["em", "l", "bt"].includes(_layout.template.type)) {
                    if (checkRequireFromTemplate(_layout.template, type, _layout)) {
                      if (
                        _layout.template.type === "tb" &&
                        _layout.isReadOnly === false
                      ) {
                        let pass: boolean = true;
                        let rows: any =
                          _layout.value?.row || _layout.value?.data?.row || _layout.data?.row;
                        let errorCols: any[] = [];
                        if (rows) {
                          rows.forEach((row: any, idx: number) => {
                            _layout.template.attribute.column.forEach(
                              (col: any, colIdx: number) => {
                                
                                if (
                                  !col.isReadOnly &&
                                  col.isShow &&
                                  col.control.template.attribute.require ===
                                    "Y" &&
                                  col.control.template.attribute.readonly !==
                                    "Y"
                                ) {
                                  console.log({ col });

                                  if (
                                    !row[colIdx].value ||
                                    row[colIdx].value === "" ||
                                    row[colIdx].value === "--select--" ||
                                    row[colIdx].value ===
                                      "-- Please Select --" ||
                                    (col.control.template.type === "c" &&
                                      isNaN(Number(row[colIdx].value)))
                                  ) {
                                    errorCols.push(
                                      <li>
                                        {`${col.control.template.label
                                        } in row ${idx + 1}`}
                                      </li>
                                    );
                                    pass = false;
                                  }
                                }
                              }
                            );
                          });
                        }
                        if (rows?.length === 0 || rows === null) {
                          _layout.template.attribute.column.forEach(
                            (col: any, colIdx: number) => {
                              if (
                                col.control.template.attribute.require === "Y"
                              ) {
                                errorCols.push(
                                  <li>{`${col.control.template.label} `}</li>
                                );
                                pass = false;
                              }
                            }
                          );
                        }
                        if (!pass) {
                          errorList.push(
                            <li>
                              {`Please fill in the following fields: `}
                              <ul>{errorCols}</ul>
                            </li>
                          );
                        }
                      } else {
                        const val = _layout.data.value;
                        if (
                          [
                            "---Select---",
                            "-- Please Select --",
                            "--Please Select--",
                            "--select--",
                            undefined,
                            null,
                          ].includes(val)
                        ) {
                          errorList.push(
                            <li>{_layout.template.label} is require.</li>
                          );
                        }
                      }
                    }
                  }
                }
              })
            );
            if (errorList.length > 0) {
              toggleAlert({
                key: "Approve Error",
                type: "error",
                message: "Require field error",
                description: (
                  <div>
                    <span>Please fill all Require field.</span>
                    <br />
                    <ul>{errorList}</ul>
                  </div>
                ),
                duration: 4,
              });
              setLoad(false);

              return;
            }
            if (autoNumFormat?.rowIndex !== -1) {
              const runningNumber = await CheckSaveAutonumber(
                requestDetail.memoDetail.template_id,
                templateDescJson,
                autoNumFormat
              );

              if (runningNumber) {
                listControlRunning.push(runningNumber);
              }
            }
            requestDetail.memoDetail.template_desc =
              JSON.stringify(templateDescJson);
          }
        }
        requestDetail["listControlRunning"] = listControlRunning;
        try {
          let _ActionMemoPage = await ActionMemoPage({
            MemoPage: {
              listApprovalDetails: requestDetail.listApprovalDetails,
              listFileAttachDetails: requestDetail.listFileAttachDetails,
              listFormName: requestDetail.listFormNames,
              listHistoryDetails: requestDetail.listHistoryDetails,
              listRefDocDetails: requestDetail.listRefDocDetails,
              memoDetail: requestDetail.memoDetail,
              listControlRunning: requestDetail.listControlRunning,
            },
            Type: type,
          });

          if (
            _ActionMemoPage?.messageType?.toLowerCase() === "success" ||
            _ActionMemoPage?.message?.toLowerCase().includes("done")
          ) {
            toggleAlert({
              description: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: _ActionMemoPage.message,
                  }}
                />
              ),
              message: type,
              type: "success",
              duration: 15,
            });
            //await Promise.all([fetchWorklist(), getMyMemoStatus()]);
            await getMyMemoStatus();
            await fetchWorklist(taskGourp, false, false, false);

            let ddd = document.getElementsByTagName("body");
            ddd[0].style.overflow = "none";
            setIsCardLoading(false);
            setToggleDetail(false);
          } else {
            toggleAlert({
              description: `${_ActionMemoPage.message}`,
              message: `Error`,
              type: "error",
            });
            await getMyMemoStatus();
            await fetchWorklist(taskGourp, false, false, false);
            setIsCardLoading(false);
          }
        } catch (error) {
          console.error("memo=>", error);
        }
      }
    } catch (error) {
      console.error("memo=>", error);
    }
    setLoad(false);
  };

  const initialActionFiedFormLineApprove = async (
    dataLineApprove: any,
    _templateDesc: any,
    _memoDetail: any,
    ReqConditions: any,
    _isCopy: boolean,
    reqListForm?: any,
  ) => {
    let _jsonValue: IApprovaReadHide[] = [];
    let currentApprovals: IReqConditions;
    const _datalineapprove = dataLineApprove;
    // template setting readonly
    const TempCurrentApprovals = _datalineapprove.find(
      (e: any) => e.sequence === _memoDetail.current_approval_level
    );
    currentApprovals = TempCurrentApprovals;

    if (
      _memoDetail.status === "Wait for Comment" &&
      _memoDetail.status === "Wait for Process" &&
      _memoDetail.current_approval_level !== 0
    ) {
      const WaitForCommentcondition = _datalineapprove.find(
        (e: any) => e.sequence == _memoDetail.current_approval_level
      );
      currentApprovals = WaitForCommentcondition;
      if (
        WaitForCommentcondition &&
        WaitForCommentcondition.ColumnJsonCondValue
      ) {
        _jsonValue = deserializeColumnJsonCondValue(
          WaitForCommentcondition.ColumnJsonCondValue
        );
      }
    }
    const isRequestor =
      _memoDetail.requestor.EmployeeId === userData.EmployeeId;
    const hasUserCondition = _datalineapprove.some((line: any) => {
      return line.approver?.EmployeeId === userData.EmployeeId;
    });

    const current_approval = _datalineapprove.find(
      (e: any) => e.sequence === _memoDetail.current_approval_level && userData.EmployeeId === e?.approver?.EmployeeId
    )
    if (
      !_isCopy &&
      _memoDetail.status !== "Completed" &&
      !isRequestor && !hasUserCondition &&
      _memoDetail.current_approval_level !== 0 &&
      (!currentApprovals ||
        currentApprovals.ColumnJsonCondValue == null ||
        currentApprovals.ColumnJsonCondValue == undefined ||
        currentApprovals.ColumnJsonCondValue == "")
    ) {
      console.log(_datalineapprove, "_datalineapprove");

      return _templateDesc;
    }

    if (_memoDetail.current_approval_level === 0) {
      // check logic version if version = 2 The ReqConditions will be not null
      if (!!ReqConditions?.Conditions?.ColumnJsonCondValue) {
        // for show/hide, read-only logic version 2
        _jsonValue = JSON.parse(
          ReqConditions.Conditions.ColumnJsonCondValue
        ).Conditions;
      } else {
        // for show/hide, read-only logic version 1
        _jsonValue = _datalineapprove
          .map((e: any) =>
            deserializeColumnJsonCondValue(e.ColumnJsonCondValue)
          )
          .reduce((pre: any[], cur: any[]) => [...pre, ...cur], [])
          .filter((e: any) => e.isRequester == "Y");
      }
    } else {
      const condition =
        _datalineapprove.find(
          (e: any) => e.sequence == _memoDetail.current_approval_level
        ) ??
        _datalineapprove.findLast((e: any) => e.emp_id == userData.EmployeeId);
      const isApproverWithNoApproveType = !!current_approval && !!!condition.ColumnJsonCondValue && _.isNull(condition?.ApproveType)
      if (
        hasUserCondition &&
        isRequestor &&
        condition &&
        condition?.ColumnJsonCondValue
      ) {
        _jsonValue = deserializeColumnJsonCondValue(
          condition.ColumnJsonCondValue
        );
      } else if (isRequestor && !hasUserCondition || isApproverWithNoApproveType) {
        const Listreq = reqListForm;
        const advance =
          Listreq?.AdvanceForm && JSON.parse(Listreq?.AdvanceForm);
        if (
          advance &&
          advance?.ReqConditions?.Conditions?.ColumnJsonCondValue
        ) {
          const advanceJsonCondValue = JSON.parse(
            advance?.ReqConditions?.Conditions?.ColumnJsonCondValue
          );
          if (!!advanceJsonCondValue.Conditions.length) {
            _jsonValue = advanceJsonCondValue.Conditions;
          } else {

            const WaitForCommentcondition = _datalineapprove.find(
              (e: any) => e.sequence == _memoDetail.current_approval_level
            );
            currentApprovals = WaitForCommentcondition;
            if (
              WaitForCommentcondition &&
              WaitForCommentcondition.ColumnJsonCondValue
            ) {
              _jsonValue = deserializeColumnJsonCondValue(
                WaitForCommentcondition.ColumnJsonCondValue
              );
            }
            // const advanceJsonCondValue = JSON.parse(
            //   "{\"Conditions\":[{\"action\":\"hide\",\"fieldaction\":[{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"key\":\"ข้อเสนอแนะจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"key\":\"ความคิดเห็นจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"key\":\"ข้อเสนอแนะจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"key\":\"ความคิดเห็นจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการฝ่ายสินเชื่อ\",\"key\":\"ข้อเสนอแนะจากผู้จัดการฝ่ายสินเชื่อ\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการฝ่ายสินเชื่อ\",\"key\":\"ความคิดเห็นจากผู้จัดการฝ่ายสินเชื่อ\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจาก Parts MKT SA-Pricing\",\"key\":\"ข้อเสนอแนะจาก Parts MKT SA-Pricing\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจาก Parts MKT SA-Pricing\",\"key\":\"ความคิดเห็นจาก Parts MKT SA-Pricing\",\"type\":\"r\"},{\"label\":\"at : Cost sheet\",\"key\":\"Cost sheet\",\"type\":\"at\"},{\"label\":\"r : ความคิดเห็นจากกรรมการผู้จัดการใหญ่\",\"key\":\"ความคิดเห็นจากกรรมการผู้จัดการใหญ่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากกรรมการผู้จัดการใหญ่\",\"key\":\"ข้อเสนอแนะจากกรรมการผู้จัดการใหญ่\",\"type\":\"ta\"}],\"isRequester\":\"N\"}]}"
            // );
            //todo
            // console.log(memoDetail ,memoDetail?.template_id, "memoDetail?.template_id");
            //  let requestDetail: any = await GetMemoDetail({...reqBodyMemo,TemplateId :memoDetail?.template_id ,Memoid  :0 }); // beam
            // const reqListForm = requestDetail?.requestDetails?.listFormNames[0];
            // _jsonValue = advanceJsonCondValue.Conditions;
          }
        }
      } else if (condition && condition?.ColumnJsonCondValue) {
        _jsonValue = deserializeColumnJsonCondValue(
          condition.ColumnJsonCondValue
        );
      }
    }

    _jsonValue?.forEach((jsonValue) => {
      const fieldaction = jsonValue.fieldaction.filter((e) => e.key);
      fieldaction.forEach((fieldAction) => {
        _templateDesc.map((layout: any) =>
          layout.layout.map((e: any) => {
            const findTemp = checkIsCorrect(
              fieldAction.key.split(" : ")[0],
              LogicOperatorType.Equal,
              e.template.label
            );

            if (findTemp) {
              if (e.template.type !== "tb") {
                if (jsonValue.action === "readonly") {
                  e.isReadOnly = true;
                } else if (jsonValue.action === "editable") {
                  e.isEditable = true;
                } else {
                  e.isShow = false;
                }
              } else {
                const fieldSplited = fieldAction.key.split(" : ");

                if (fieldSplited[1]) {
                  e.template.attribute.column.forEach((col: any) => {
                    const targetCol = checkIsCorrect(
                      fieldSplited[1],
                      LogicOperatorType.Equal,
                      col.label
                    );

                    if (targetCol) {
                      if (jsonValue.action === "readonly") {
                        col.isReadOnly = true;
                      } else if (jsonValue.action === "editable") {
                        col.isEditable = true;
                      } else {
                        col.isShow = false;
                      }
                    }
                  });
                } else {
                  if (jsonValue.action === "readonly") {
                    e.isReadOnly = true;
                  } else if (jsonValue.action === "editable") {
                    e.isEditable = true;
                  } else {
                    e.isShow = false;
                  }
                }
              }
            }

            return e;
          })
        );
      });
    });

    return _templateDesc;
  };
  const prepareInitialLogic = async (
    logics: ILogic[],
    templateDesc: any,
    memoDetail: IMemoDetailModel,
    _lineApproval: any[]
  ) => {
    let _templateDesc = templateDesc;

    for (let i = 0; i < logics?.length; i++) {
      const logic = logics[i];
      if (logic.logictype === "role") {
        let showTemplate: {
          isShow: boolean;
          pos: {
            row: number;
            col: number;
            tableCols?: number[];
            notUseCols?: number[];
          }[];
          readonly?: boolean;
          notInPos: { row: number; col: number }[];
        } = { isShow: false, pos: [], notInPos: [] };

        const jsonValue: ILogicTypeShowHide =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue);

        if (jsonValue.action !== "showpdf") {
          if (jsonValue.roleids && jsonValue.roleids.length > 0) {
            let userRole: IRolePermission[] = [];
            let roles: IRolePermission[] = await GetRolePermissionByUser();
            if (memoDetail.status === "Wait for Process") {
              const currentApproval = _lineApproval?.find(
                (e: any) => e.sequence == memoDetail.current_approval_level
              ).emp_id;
              userRole = roles.filter(
                (r) =>
                  r.IsDelete === false &&
                  r.EmployeeId === currentApproval.emp_id
              );
            } else {
              userRole = roles.filter(
                (r) =>
                  r.IsDelete === false && r.EmployeeId === userData.EmployeeId
              );
            }

            const isShow = onCheckUserRolePermissionInLogic(
              userRole,
              jsonValue.roleids
            );

            if (jsonValue.action === "readonly") {
              showTemplate.readonly = true;
            }
            showTemplate.isShow = isShow;

            if (jsonValue.fieldaction) {
              for (let k = 0; k < jsonValue.fieldaction.length; k++) {
                const field = jsonValue.fieldaction[k];
                for (let i = 0; i < _templateDesc.items.length; i++) {
                  const templateItems = _templateDesc.items[i];
                  for (let j = 0; j < templateItems.layout.length; j++) {
                    const templateLayouts = templateItems.layout[j];

                    if (
                      field.lable === templateLayouts.template.label ||
                      field.isInTable === templateLayouts.template.label ||
                      field === templateLayouts.template.label
                    ) {
                      if (templateLayouts.template.type === "tb") {
                        let targetCols: number[] = [];
                        let notTargetCols: number[] = [];

                        templateLayouts.template.attribute.column.forEach(
                          (e: any, colIndex: number) => {
                            if (e.label === field.lable) {
                              targetCols?.push(colIndex);
                            } else {
                              notTargetCols.push(colIndex);
                            }
                          }
                        );
                        showTemplate.pos.push({
                          row: i,
                          col: j,
                          tableCols: targetCols,
                          notUseCols: notTargetCols,
                        });
                      } else {
                        showTemplate.pos.push({
                          row: i,
                          col: j,
                        });
                      }
                    } else {
                      showTemplate.notInPos.push({
                        row: i,
                        col: j,
                      });
                    }
                  }
                }
              }
            }

            if (showTemplate.pos.length > 0) {
              for (let i = 0; i < showTemplate.pos.length; i++) {
                const pos = showTemplate.pos[i];
                if (
                  _templateDesc.items[pos.row].layout[pos.col].template.type ===
                  "tb"
                ) {
                  _templateDesc.items[pos.row].layout[pos.col].isShow = true;
                  _templateDesc.items[pos.row].layout[
                    pos.col
                  ].template.attribute.column = _templateDesc.items[
                    pos.row
                  ].layout[pos.col].template.attribute.column.map(
                    (column: any, colIndex: number) => {
                      if (column.label !== "rowstate") {
                        if (pos.tableCols?.includes(colIndex)) {
                          if (showTemplate.readonly) {
                            column.control.template.attribute.require = "Y";
                          }

                          column.isShow =
                            jsonValue.action !== "hide" ? isShow : !isShow;
                        }
                      } else {
                        column.isShow = false;
                      }

                      return column;
                    }
                  );
                } else {
                  if (jsonValue.action === "readonly") {
                    _templateDesc.items[pos.row].layout[pos.col].isReadOnly =
                      isShow;
                  } else {
                    _templateDesc.items[pos.row].layout[pos.col].isShow =
                      jsonValue.action !== "hide" ? isShow : !isShow;
                  }
                }
              }
            }
          }
        }
      } else if (logic.logictype === LogicType.HideControl) {
        const jsonValue: ILogicTypeHideControl = JSON.parse(logic.jsonvalue);

        const isTable = processHideControlLogic(
          jsonValue,
          _templateDesc.items,
          { process: "isShow" },
          memoDetail,
          userData
        );
      } else if (logic.logictype === LogicType.ReadOnlyControl) {
        const jsonValue: ILogicTypeReadOnly = JSON.parse(logic.jsonvalue);

        const isTable = processHideControlLogic(
          jsonValue,
          _templateDesc.items,
          { process: "isReadOnly" },
          memoDetail,
          userData
        );
      }
    }
  };
  const detechAutonumberFormula = (templateDesc: any) => {
    try {
      let _autoFormats: IAutoNumberAttibute = {
        formats: [],
        showSymbol: "-",
        digit: 0,
        rowIndex: -1,
        colIndex: -1,
      };

      templateDesc.items.forEach((item: any, rowIdx: number) => {
        item.layout.forEach((layout: any, colIdx: number) => {
          if (layout.template.type === "an") {
            _autoFormats.formats = layout.template.attribute.formats;
            _autoFormats.showSymbol = layout.template.alter.includes("|")
              ? ""
              : layout.template.symbol;
            _autoFormats.digit = layout.template.digit;
            _autoFormats.rowIndex = rowIdx;
            _autoFormats.colIndex = colIdx;
          }
        });
      });

      return _autoFormats;
    } catch (error) {
      return {
        formats: [],
        showSymbol: "-",
        digit: 0,
        rowIndex: -1,
        colIndex: -1,
      };
    }
  };
  const CheckSaveAutonumber = async (
    templateId: Number,
    template_desc: any,
    autoNumFormat: IAutoNumberAttibute
  ) => {
    try {
      const rowIndex = autoNumFormat.rowIndex;
      const colIndex = autoNumFormat.colIndex;
      if (template_desc) {
        let value = template_desc.items[rowIndex].layout[colIndex].data.value;
        const autoTemp = template_desc.items[rowIndex].layout[colIndex];
        if (value) {
          let requestBody = null;
          let newRunning = -1;
          if (autoNumFormat.showSymbol) {
            const runningSplit = value.split(autoNumFormat.showSymbol);
            const runningPrefix = runningSplit.slice(
              0,
              runningSplit.length - 1
            );
            requestBody = {
              Prefix:
                runningPrefix.join(autoNumFormat.showSymbol) +
                autoNumFormat.showSymbol,
              Digit: autoTemp.template.digit,
              TemplateId: templateId,
              RunningNumber: runningSplit.join(autoNumFormat.showSymbol),
            };
            const checkAuto = await GetAutoNumber(requestBody);
            const checkNum = checkAuto.split(autoNumFormat.showSymbol);
            if (checkNum[0] !== "") {
              newRunning = checkNum[checkNum.length - 1];
              runningSplit[runningSplit.length - 1] = newRunning;
              requestBody.RunningNumber =
                runningPrefix.join(autoNumFormat.showSymbol) +
                autoNumFormat.showSymbol +
                newRunning;
            }
          } else {
            requestBody = {
              Prefix: autoNumFormat.fisrtPreix,
              Digit: autoTemp.template.digit,
              TemplateId: templateId,
              RunningNumber: value,
            };
            const checkAuto = await GetAutoNumber(requestBody);
            const checkNum = checkAuto.replaceAll(autoNumFormat.fisrtPreix, "");
            let dd = value.replaceAll(autoNumFormat.fisrtPreix, "");
            if (checkNum !== "") {
              newRunning = checkNum;
              dd = newRunning;
              if (autoNumFormat?.fisrtPreix) {
                requestBody.RunningNumber =
                  autoNumFormat?.fisrtPreix + newRunning;
              }
            }
          }

          return requestBody;
        }
      }
    } catch (error) {
      console.error("auto=>CheckSaveAutonumber=>error", error);
    }
  };
  const setContent = async (
    memoId: number,
    status: string,
    index: number,
    requestor: IUserModel
  ) => {
    // const _empData = empData.employeeData;

    const _memoDetail = await GetAllMemo({
      memoid: memoId,
      EmployeeId: requestor?.EmployeeId?.toString(),
      SecretId: "",
      actor: userData.EmployeeId,
    });

    if (_memoDetail.length > 0) {
      if (_memoDetail[0].Permission !== null) {
        if (_memoDetail[0].Permission.View === "F") {
          setIsShowPdfData(false);
        }
      }
    }

    if (currentIndex !== index) {
      setCurrentMemoId(Number(memoId));
      setCurrentIndex(index);
      setToggleDetail(true);
      sessionStorage.setItem("currentMemoId", memoId.toString());
    } else {
      setCurrentIndex(index);

      if (toggleDetail) {
        setCurrentMemoId(0);
        setToggleDetail(false);
        sessionStorage.setItem("currentMemoId", "0");
      } else {
        setCurrentMemoId(Number(memoId));
        setToggleDetail(true);
        sessionStorage.setItem("currentMemoId", memoId.toString());
      }
    }
    const actor = {
      EmployeeId: userData.EmployeeId,
    };
    // setToggleDetail(false);
    let _dataAttachfiles = await GetAllAttachFiles({ memoid: memoId });

    let _dataApprovals = await GetAllApprovals({ memoid: memoId });

    if (status !== "Draft") {
      let memoButton: IMemoButtonModel = {
        actor: {
          EmployeeId: userData.EmployeeId,
        },
        memoid: memoId,
      };
      let _dataMemobutton = await GetButtonMemoByMemoId(memoButton);
      setMenuButton(_dataMemobutton);
    } else {
      setMenuButton([]);
    }

    let _dataHistory = await GetAllHistory({
      Memoid: memoId,
      SecretId: "",
      actor: actor,
    });

    setOnDetailLoading(false);

    setSelectedCard((prevState) => ({
      ...prevState,
      approvals: _dataApprovals,
      attachfiles: _dataAttachfiles,
      requestor,
      MemoID: memoId,
      history: _dataHistory,
    }));

    sessionStorage.setItem(
      "selectedCard",
      selectedCard ? JSON.stringify(selectedCard) : "{}"
    );

    setSidebarState(false);
    if (currentIndex !== index) {
      setCurrentMemoId(Number(memoId));
      setCurrentIndex(index);
      setToggleDetail(true);
      sessionStorage.setItem("currentMemoId", memoId.toString());
    } else {
      setCurrentIndex(index);

      if (toggleDetail) {
        setCurrentMemoId(0);
        setToggleDetail(false);
        sessionStorage.setItem("currentMemoId", "0");
      } else {
        setCurrentMemoId(Number(memoId));
        setToggleDetail(true);
        sessionStorage.setItem("currentMemoId", memoId.toString());
      }
    }
  };
  const onSelectTask = (text: WorklistHeaderType) => {
    setTaskHeader(text);
    let date: [Moment?, Moment?] | null = null;
    let task: TodoType = "todo";
        let rawObject = { ...searchObject };
    if (text !== "Related List") {
      rawObject.date = [];
       setDefaultValue([])
    }
      setSearchObject((prevState: any) => ({
          ...prevState,
          ...rawObject,
      }));
      console.log({
          ...searchObject,
          ...rawObject,
      });
      let dataToChange = {
          ...searchObject,
          ...rawObject,
      }
      sessionStorage.setItem("searchObject", JSON.stringify(searchObject));

    if (text === "All Task Group") {
      task = "todo";
    } else if (text === "To Do List") {
      task = "todo";
    } else if (text === "Related List") {
      task = "myrelate";
    } else if (text === "In Process") {
      task = "inprocess";
    } else if (text === "Completed") {
      task = "completed";
    } else if (text === "Cancelled") {
      task = "cancelled";
    } else if (text === "Rejected") {
      task = "rejected";
    }
    fetchWorklist(task,false, text === "Related List" ? true : false, text === "Related List" ? true : false ,dataToChange);
    setCurrentPage(1);
    setDefaultTask(text);
    sessionStorage.setItem("task", task);
    sessionStorage.setItem("headerTask", text);
    sessionStorage.setItem("page", "1");
    setIsCardLoading(false);
    setLoad(false);
  };
  const onSelectChange = async (
    value: any | any[],
    formSelect: WorklistSerachType
  ) => {
    let rawObject = searchObject;

    if (formSelect) {
      rawObject[formSelect] = value;

      if (formSelect === "date") {
        // fetchWorklist(taskGourp, false, false, false);
      } else {
        setSearchObject((prevState: any) => ({
          ...prevState,
          ...rawObject,
        }));

        sessionStorage.setItem("searchObject", JSON.stringify(searchObject));
      }

      setCurrentPage(1);
      setIsCardLoading(false);
      sessionStorage.setItem("page", "1");
    }
  };

  const clearFilter = () => {
    localStorage.removeItem("workListFilterDate")
    localStorage.removeItem("workListFilterDate2")
    setSearchObject({
      date: [],
      form: [],
      status: [],
      company: [],
      department: [],
      keyword: "",
    });
    setCurrentPage(1);
    sessionStorage.setItem("searchObject", JSON.stringify(searchObject));
    fetchWorklist(taskGourp, true, false, false, {
      date: [],
      form: [],
      status: [],
      company: [],
      department: [],
      keyword: "",
    });
    // if (taskGourp == "myrelate") {
    //   fetchWorklist("myrelate", null);
    // }
  };
  const paginate = (page: number) => {
    setCurrentPage(page);
  };
  const onSetItemPerPage = (numItem: any) => {
    setItemPerPage(numItem);
  };

  const mapWorklistCard = (todo: ITodo, idx: number) => {
    return (
      <WorklistCardComponent
        // id={idx}
        dataWorklist={dtWorkListData}
        key={idx}
        data={todo}
        onUpdate={onUpdateMemo}
        currentMemoId={currentMemoId}
        setContent={setContent}
        index={idx}
        taskGourp={taskGourp}
        toggleDetail={toggleDetail}
        setToggleDetail={setToggleDetail}
        setOnDetailLoading={setOnDetailLoading}
      />
    );
  };
  
  const firstRetrieveData = async () => {
    let actionBack = sessionStorage.getItem("action_back");
    let task = taskGourp;
    if (actionBack) {
      task = sessionStorage.getItem("task")
        ? (sessionStorage.getItem("task") as TodoType)
        : "todo";
    }
    // await fetchWorklist(task, false, false, false);
    if (actionBack) {
      let search = sessionStorage.getItem("searchObject")
        ? JSON.parse(sessionStorage.getItem("searchObject")!)
        : searchObject;
      let page = sessionStorage.getItem("page")
        ? parseInt(sessionStorage.getItem("page")!)
        : 1;
      let selecteCard = sessionStorage.getItem("selectedCard")
        ? (JSON.parse(
          sessionStorage.getItem("selectedCard")!
        ) as IWorklistDetail)
        : selectedCard;
      let taskHeader: string = sessionStorage.getItem("headerTask")
        ? sessionStorage.getItem("headerTask")!
        : "To Do List";
      let currentMemoId = sessionStorage.getItem("currentMemoId")
        ? parseInt(sessionStorage.getItem("currentMemoId")!)
        : 0;
      let sidebar: boolean = sessionStorage.getItem("toggleSidebar")
        ? JSON.parse(sessionStorage.getItem("toggleSidebar")!)
        : false;
        
      setSearchObject(search);
      setCurrentPage(page);
      setSelectedCard(selecteCard);
      setDefaultTask((taskHeader as WorklistHeaderType) || "To Do List");
      setTaskHeader(taskHeader);
      setCurrentMemoId(currentMemoId);
      setSidebarState(sidebar);
    }
    sessionStorage.removeItem("action_back");
  };

  const isDiffPreviousQue = (current: number[], previous: number[]) => {
    return current.join(",") != previous.join(",");
  };

  // useMemo(() => {
  //   if (
  //     processQue?.length == 0 &&
  //     isDiffPreviousQue(processQue, previousQue.current)
  //   ) {
  //     fetchWorklist(taskGourp, true, false, false);
  //   }
  //   previousQue.current = [...processQue];
  // }, [processQue]);
  const { masterSetting } = useMasterSetting();

  const calFlexLayout = () => {
    if (!masterSetting["splitPage"]) return { workList: 1, content: 1 };
    const { Value1, Value2 } = masterSetting["splitPage"];
    const a = Number(Value1);
    const b = Number(Value2);
    if (Number(a) + Number(b) != 1 || !a || !b)
      return { workList: 1, content: 1 };
    return { workList: a * 2, content: b * 2 };
  };

  return (
    <div className="main-worklist">
      <AnimatePresence>
        <div className="main-container">
          {isCardLoading && (
            <div className="logo-loading">
              <img src={props.responeConfig?.pathLoading} alt="loading..." />
            </div>
          )}
          <div
            className="worklist-container"
            style={
              {
                "--container-flex": !toggleDetail
                  ? 1
                  : calFlexLayout().workList,
              } as React.CSSProperties
            }
          >
            <div className="header-container">
              {sidebarState ? (
                <div className="mobile">
                  <div className="content filter-content">
                    <div className="worklist-filter-container">
                      <p className="clear-all-button" onClick={clearFilter}>
                        {t("Clear all")}
                      </p>
                      <div className="all-filter-container">
                        <WorkListSideBarElementUse
                          onBlur={() => {
                            fetchWorklist(taskGourp, false, false, false);
                          }}
                          searchObject={searchObject}
                          onSelectChange={onSelectChange}
                          onSelectTask={onSelectTask}
                          formStatus={formStatusOptions}
                          allCompany={companiesOptions}
                          allDepartment={departmentsOptions}
                          formType={formTypeOptions}
                          defaultTask={defaultTask}
                          defaultValue={defaultValue}
                          setDefaultValue={setDefaultValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="button-container">
                <Button
                  type="text"
                  icon={<IoMenu size={28} />}
                  size="large"
                  onClick={toggleSideBar}
                  style={{ background: "transparent " }}
                />
                <TreeSelectNewRequest />
              </div>
              <div className="route-text-container">
                <p className="route-text">
                  {t("Worklist")} / {t(taskHeader)} (
                  {totalCount?.toLocaleString()})
                </p>
              </div>
            </div>
            <div className="content">
              <div className="worklist-items-container">
                {sidebarState && (
                  <motion.div
                    className="desktop"
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -200 }}
                    transition={{ duration: 0.4 }}
                  >
                    <div className="content filter-content">
                      <div className="worklist-filter-container">
                        <p className="clear-all-button" onClick={clearFilter}>
                          {t("Clear all")}
                        </p>
                        <div className="all-filter-container">
                          <WorkListSideBarElementUse
                            onBlur={() => {
                              fetchWorklist(taskGourp, false, false, false);
                            }}
                            searchObject={searchObject}
                            onSelectChange={onSelectChange}
                            onSelectTask={onSelectTask}
                            formStatus={formStatusOptions}
                            allCompany={companiesOptions}
                            allDepartment={departmentsOptions}
                            formType={formTypeOptions}
                            defaultTask={defaultTask}
                            defaultValue={defaultValue}
                            setDefaultValue={setDefaultValue}
                          />
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
                <div className="worklist-cards-container">
                  <div className="item-per-page-container">
                    <span className="text-show">{t("Show")}</span>
                    <InputNumber
                      type={"number"}
                      size="small"
                      min={1}
                      max={100}
                      value={itemPerPage}
                      onBlur={() => fetchWorklist(taskGourp, false, false, false)}
                      onChange={(e) => {
                        onSetItemPerPage(e ?? 1);
                      }}
                    />
                    <span className="text-items-per-page">
                      {t("items per page")}
                    </span>
                  </div>
                  <div className="cards-container">
                    {isCardLoading && (
                      <div className="logo-loading">
                        <img
                          src={props.responeConfig?.pathLoading}
                          alt="loading..."
                        />
                      </div>
                    )}
                    {workListData?.map(mapWorklistCard)}
                  </div>
                  <Pagination
                    defaultCurrent={1}
                    current={currentPage}
                    pageSize={itemPerPage ?? 1}
                    total={totalCount}
                    onChange={paginate}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}></div>
            <FooterComponents />
          </div>
          {toggleDetail && (
            <DetailContentScreen
              calFlexLayout={calFlexLayout()}
              setButtonType={setButtonType}
              buttonType={buttonType}
              data={selectedCard}
              isShowPdfData={isShowPdfData}
              menuButton={menuButton}
              onUpdate={onUpdateMemo}
              onDetailLoading={onDetailLoading}
              currentMemoId={currentMemoId}
            />
          )}
        </div>
      </AnimatePresence>
    </div>
  );
};
export default withPerMission(WorkListScreen);
